const Question = () =>
  import(
    /* webpackChunkName: "questionnaire-question" */ '@/pages/questionnaire/question/index.vue'
  )

const CreateQuestion = () =>
  import(
    /* webpackChunkName: "questionnaire-question" */ '@/pages/questionnaire/question/create.vue'
  )

const EditQuestion = () =>
  import(
    /* webpackChunkName: "questionnaire-question" */ '@/pages/questionnaire/question/edit.vue'
  )

export default {
  path: 'question',
  meta: {
    label: 'question',
    auth: 'question'
  },
  component: {
    name: 'Question',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'QuestionnaireQuestion',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Question
    },
    {
      name: 'QuestionnaireCreateQuestion',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateQuestion
    },
    {
      name: 'QuestionnaireEditQuestion',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditQuestion,
      props: true
    },
  ]
}
